export default __webpack_public_path__ + "static/estimator-2d96de65fc6c95bb28a66a39ee848859.gif";